import React from "react";
import { Profile } from "../../../assets/images";
import { colors } from "../../../styles";
import {
  Action,
  ActionInfo,
  Body,
  Container,
  CreationDate,
  Header,
  Id,
  Name,
  Origin,
  Thumbnail
} from "./styles";

function TicketActions({ actions }) {
  function getHeaderColor(origin) {
    switch (origin) {
      case "Chat":
        return colors.chat;
      case "Email":
        return colors.email;
      case "RemoteAccess":
        return colors.remoteAccess;
      case "Telephony":
        return colors.telephony;
      default:
        return colors.public;
    }
  }

  return (
    <Container>
      {actions &&
        actions.map(
          ({ createdBy, createdDate, origin, number, htmlDescription }) => (
            <Action key={String(number)}>
              <Thumbnail src={Profile} styles={{ heigth: "40px" }} />
              <ActionInfo>
                <Header borderColor={() => getHeaderColor(origin)}>
                  <div>
                    <Name>
                      {createdBy && createdBy.businessName
                        ? createdBy.businessName
                        : ""}
                    </Name>
                    <CreationDate>{createdDate}</CreationDate>
                  </div>
                  <div>
                    {/* <Origin>{origin !== "Public" ? origin : ""}</Origin> */}
                    <Id>{number}</Id>
                  </div>
                </Header>
                <Body>
                  <div dangerouslySetInnerHTML={{ __html: htmlDescription }} />
                </Body>
              </ActionInfo>
            </Action>
          )
        )}
    </Container>
  );
}

export default TicketActions;
